<template>
  <div class="product-details">
    <div class="title">
      {{ title }}产品明细
    </div>
    <div class="row flex">
      <div class="select-box">
        <el-autocomplete
          v-model="storageValue"
          disabled
          :fetch-suggestions="queryStorageName"
          placeholder="批量设置库位"
          style="width: 270px;"
        />
        <el-button type="primary" size="mini" class="ml-18 btn-setting" disabled @click="setStorageValue">
          设置
        </el-button>
      </div>
      <div class="address-box">
        <!-- 退货地址: {{ `${data.address},${data.receiverName},${data.telephone}` }} -->
      </div>
    </div>
    <!-- table row -->
    <div class="table-box">
      <el-table
        ref="multipleTable"
        :data="data.tableData"
        border
        tooltip-effect="dark"
        style="width: 100%"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          align="left"
          width="55"
          fixed="left"
        />
        <el-table-column
          prop="productCode"
          label="销售产品代码"
          align="left"
        />
        <el-table-column
          prop="productName"
          label="产品型号"
          align="left"
        />
        <el-table-column
          prop="materialNum"
          label="料号"
          align="left"
        />
        <el-table-column
          prop="productNum"
          label="数量"
          align="left"
        />
        <el-table-column
          prop="beforeSplitPrice"
          label="拆分前单价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productPriceAdd"
          label="拆分前总价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productActualPrice"
          label="实际结算单价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productActualPriceAdd"
          label="实际结算总价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="erpLineNum"
          label="ERP行号"
          align="left"
        />
        <el-table-column
          prop="materialUnit"
          label="单位"
          align="left"
        />
        <el-table-column
          prop="storageName"
          label="库位"
          align="left"
          width="160px"
        >
          <template slot-scope="scope">
            {{ scope.row.storageName || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="taxRate"
          label="税率"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="fictitiousReturn"
          label="虚拟退/真实退"
          align="left"
        >
          <template v-slot="scope">
            {{ scope.row.fictitiousReturn ? '真实退' : '虚拟退' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="remarks"
          label="备注"
          align="left"
        >
          <template v-slot="scope">
            {{ scope.row.remarks || '-' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui';
import { getStorageByKeyWords } from '@/API';

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      options: [
        { label: '库位1', value: 'one' },
        { label: '库位2', value: 'two' },
        { label: '库位3', value: 'three' }
      ],
      tableData: [],
      multipleSelection: [],
      storageValue: ''
    };
  },
  components: {},
  computed: {
    // 判断设置按钮和下拉框是否可操作
    isDisabled () {
      if (this.multipleSelection.length < 2) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    // 查询库位名
    queryStorageName (val, cb) {
      let noneList = [];
      if (!val) return cb(noneList);

      getStorageByKeyWords({ keyWords: val }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let list = JSON.parse(json.data);
          console.log(list);
          let arr = list.map(item => ({
            value: item.storageName
          }));
          cb(arr);
        }
      }).catch(() => {});
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    // 表格合计逻辑
    getSummaries (params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const noSumList = [1, 2, 3, 5, 7, 9, 10, 11, 12, 13, 14];
        if (noSumList.includes(index)) {
          sums[index] = '';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          });
          sums[index] += '';
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // 批量设置库位
    setStorageValue () {
      if (!this.storageValue) {
        return Message.info('请先选择库位');
      }
      console.log();
      this.data.tableData.forEach(item => {
        item.storageName = this.storageValue;
      });
      this.storageValue = '';
      this.$refs.multipleTable.clearSelection();
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details{
  margin-top: 12px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  .title{
    color: #383838;
    font-size: 14px;
    font-weight: bold;
  }
  .row{
    margin-top: 12px;
    margin-bottom: 12px;
    font-size: 14px;
    .btn-setting{
      width: 80px;
      height: 30px;
      font-size: 14px;
    }
    .address-box{
      color: #383838;
      font-weight: bold;
    }
  }
}
.flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ml-18{
  margin-left: 18px;
}
.btn-disabled{
  color: #B8B8B8;
  font-size: 14px;
  border-radius: 4px;
  background-color: rgba(245,245,245,1);
  border: 1px solid #d9d9d9;
}
</style>

<style lang="scss" scoped>
.table-box{
  ::v-deep .el-table__footer-wrapper {
    tbody {
      td.el-table__cell{
      background-color: transparent;
      font-weight: bold;
    }
   }
  }
  ::v-deep .el-table__row{
    .el-table__cell{
      .el-select{
        width: 130px;
      }
    }
  }
}
.row{
  .select-box{
    ::v-deep .el-select{
       width: 270px;
    }
  }
}
</style>
